(function () {
    'use strict';

    angular
        .module('app.departments')
        .controller('DepartmentsListController', DepartmentsListController);

    DepartmentsListController.$inject = ['common', 'dataservice'];
    /* @ngInject */
    function DepartmentsListController(common, dataservice) {
        var vm = this;

        vm.title = 'Departments';
        vm.displayedItems = [];
        vm.items = [];
        vm.counts = [];
        vm.alertsCount = [];
        vm.completionTypesCount = [];
        vm.alertsCount = [];
        vm.refresh = refresh;
        vm.usersInDepartments = usersInDepartments;
        vm.completionTypesByDepartment = completionTypesByDepartment;
        vm.alertsByDepartment = alertsByDepartment;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin() , getItems(), getCounts()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function usersInDepartments(departmentId) {
            return _getCount(vm.counts, departmentId);
        }

        function completionTypesByDepartment(departmentId) {
            return _getCount(vm.completionTypesCount, departmentId);
        }

        function alertsByDepartment(departmentId) {
            return _getCount(vm.alertsCount, departmentId);
        }

        function _getCount(collection, departmentId) {
            for (var i = 0; i < collection.length; i++) {
                if (collection[i].Name == departmentId) {
                    return collection[i].ActiveCount;
                }
            }
        }

        function getCounts() {
            dataservice.getItems('api/Departments/CountsOfUsersInDepartment/-1').then(function (response) {
                vm.counts = response.data;
            }, function (error) { });

            dataservice.getItems('api/Departments/GetCountOfCompletionTypesByDepartment/-1').then(function (response) {
                vm.completionTypesCount = response.data;
            }, function (error) { });

            dataservice.getItems('api/Departments/GetCountOfAlertsByDepartment/-1').then(function (response) {
                vm.alertsCount = response.data;
            }, function (error) { });
            
        }

        function getItems() {
            return dataservice.getItems('api/Departments').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function refresh() {
            getItems();
        }
    }
})();
